import React from "react";

export default function OptionRowsEditor({ rows, onChange, showImpact = true }) {
  const updateRow = (index, patch) => {
    const next = rows.map((row, i) => (i === index ? { ...row, ...patch } : row));
    onChange(next);
  };

  const addRow = () => onChange([...(rows || []), { value: "", label: "", impact: "0" }]);

  const removeRow = (index) => {
    const next = (rows || []).filter((_, i) => i !== index);
    onChange(next.length ? next : [{ value: "", label: "", impact: "0" }]);
  };

  return (
    <div className="option-rows-editor">
      <table className="admin-table compact-editor-table">
        <thead>
          <tr>
            <th>Stored value</th>
            <th>Display label</th>
            {showImpact && <th>Impact %</th>}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {(rows || []).map((row, index) => (
            <tr key={index}>
              <td>
                <input
                  value={row.value}
                  placeholder="1-3Months"
                  onChange={(e) => updateRow(index, { value: e.target.value })}
                />
              </td>
              <td>
                <input
                  value={row.label}
                  placeholder="Less than 3 months"
                  onChange={(e) => updateRow(index, { label: e.target.value })}
                />
              </td>
              {showImpact && (
                <td style={{ width: 90 }}>
                  <input
                    type="number"
                    value={row.impact}
                    onChange={(e) => updateRow(index, { impact: e.target.value })}
                  />
                </td>
              )}
              <td className="actions-cell">
                <button type="button" className="admin-btn secondary" onClick={() => removeRow(index)}>
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button type="button" className="admin-btn secondary" onClick={addRow} style={{ marginTop: 8 }}>
        + Add option
      </button>
      <p className="field-hint">
        Stored value is sent to pricing APIs. Display label is what customers see in the app.
      </p>
    </div>
  );
}
